<div class="container-fluid">
  <app-pagetitle title="Machine Wise Production Report" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

  <div class="row">
    <div class="col-xl-12">
      <div class="row">
        <!-- <div *ngFor="let stat of statData" class="col-md-3"> -->
        <!-- <div class="col-md-2">
          <div class="form-group">
            <label class="mt-3">Multiple Select</label>
            <ng-multiselect-dropdown
              [placeholder]="'custom placeholder'"
              [settings]="dropdownSettings"
              [data]="deviceList"
              [(ngModel)]="selectedItems"
              (onSelect)="onItemSelect($event)"
              (onSelectAll)="onSelectAll($event)"
            >
            </ng-multiselect-dropdown>
           <ng-select [items]="deviceList" [multiple]="true"></ng-select>
          </div>
        </div> -->
        <div class="col-md-2">
          <div class="form-group">
            <label>Department</label>
            <select class="form-control custom-select" (ngModelChange)="select_Department($event)" name="departmentName"
              id="departmentName" ngModel disableOptionCentering [(ngModel)]="selectedDepartment">
              <option *ngFor="let department of departmentData" [ngValue]="department.departmentName">
                {{ department.departmentName }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label>Device</label>
            <!-- <ng-select
              id="device"
              name="deviceNameName"
              [(ngModel)]="deviceName"
              (ngModelChange)="select_Device($event)"
            >
              <ng-option
                *ngFor="let range of deviceList"
                [value]="range.deviceId"
              >
                {{ range.deviceName }}
              </ng-option>
            </ng-select> -->

            <select class="form-control custom-select" (ngModelChange)="select_Device($event)" name="deviceNameName"
              id="device" ngModel disableOptionCentering [(ngModel)]="deviceName">
              <option *ngFor="let range of deviceListData" [ngValue]="range">
                {{ range.deviceName }}
              </option>
            </select>
          </div>
        </div>
        <!-- <div class="col-md-2">
          <div class="form-group">
            <label>Report Type </label>
            <select
              class="form-control custom-select"
              (ngModelChange)="select_Report($event)"
              name="reportType"
              id="report"
              ngModel
              disableOptionCentering
              [(ngModel)]="reportType"
            >
              <option
                *ngFor="let range of reportList"
                [ngValue]="range.reportName"
              >
                {{ range.reportName }}
              </option>
            </select>
          </div>
        </div> -->
        <!-- <div class="col-md-2"> -->
        <!-- <div class="form-control"> -->
        <!-- <label>From Date</label>
          <input
            class="form-control"
            type="date"
            [(ngModel)]="fromDate"
            placeholder="{{ 'From-date' }}"
            id="example-date-input"
            [min]="mindate"
            [max]="maxdate"
            (click)="toggle()"
            (change)="changeMin()"
          /> -->
        <!-- </div> -->
        <!-- <div class="form-group">
            <label>Select Range</label>

            <select
              class="form-control"
              (ngModelChange)="rangeDataa($event)"
              name="rangeName"
              id="range"
              ngModel
              disableOptionCentering
              [(ngModel)]="selectedRange"
            >
              <option *ngFor="let range of byRange" [ngValue]="range">
                {{ range }}
              </option>
            </select>
          </div> -->
        <!-- </div> -->
        <!-- <div class="form-group col-md-2">
          <label>Date</label>
          <input class="form-control" type="date" [(ngModel)]="fromDate" placeholder="{{ 'From-date' }}"
            id="example-date-input" [min]="mindate" [max]="maxdate" (click)="toggle()" (change)="changeMin()">
        </div> -->
        <div class="form-group col-md-2">
          <label>From Date</label>
          <input class="form-control" type="date" [(ngModel)]="fromDate" placeholder="{{ 'From-date' }}"
            id="example-date-input" [min]="mindate" [max]="maxdate" (click)="toggle()" (change)="changeMin()" />
        </div>
        <div class="form-group col-md-2">
          <label>To Date</label>
          <div class="input-group">
            <input class="form-control" type="date" [(ngModel)]="toDate" placeholder="{{ 'to-date' }}"
              id="example-date-input" [min]="fromDate" [max]="maxdate" (click)="toggle()" (change)="changeMax()" />
          </div>
        </div>
        <div class="col-md-1">
          <button style="width: 100%; margin-top: 1.8rem" type="button" class="btn btn-success btn-rounded"
            [disabled]="isData" (click)="changeDate()">
            Submit
          </button>
          <!-- <button
            type="button"
            class="btn btn-primary btn-sm btns"
            (click)="changeDate()"
          >
            {{ "submit" }}
          </button> -->
        </div>
        <div class="col-md-1" *ngIf="showTable">
          <button type="button" style="width: 100%; margin-top: 1.8rem" class="btn btn-primary btn-rounded"
            (click)="openModal(templatepdf, 'downloadpdfcsv', 'Export')">
            Export
          </button>
        </div>
      </div>
    </div>
    <!-- end row -->
  </div>
  <!-- <div class="row">
    <div class="col-md-3">
      <div class="card">
        <div class="card-body">
          <span class="text-primary"> Energy</span>
          <span class="d-flex">
            <h4 class="mb-0">
              {{ currantAverage ? currantAverage : 0 }}
              <span class="txt-font">Amp</span>
            </h4>
            &nbsp; /&nbsp;
            <h4 class="mb-0">
              {{ totalPart ? totalPart : 0 }}
              <span class="txt-font">Parts</span>
            </h4>
          </span>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="card">
        <div class="card-body">
          <span class="text-primary"> T-Energy</span>
          <h4 class="mb-0">
            {{ total_energy ? total_energy : 0 }}
            <span class="txt-font"> KwH</span>
          </h4>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="card">
        <div class="card-body">
          <span class="text-primary"> R-Power</span>
          <h4 class="mb-0">
            {{ react_energy ? react_energy : 0 }}
            <span class="txt-font">W</span>
          </h4>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <div class="card">
        <div class="card-body">
          <span class="text-primary"> A-Power</span>
          <h4 class="mb-0">
            {{ appa_energy ? appa_energy : 0 }} <span class="txt-font">VA</span>
          </h4>
        </div>
      </div>
    </div>
  </div> -->
  <div class="row">
    <!-- <div class="col-md-6">
      <div class="card">
        <div class="card-body" *ngIf="!showTable">
          Please wait we are fetching data / nodata
          <img src="assets/images/noData.jpg" width="70%" />
        </div>
        <div class="card-body" *ngIf="showTable">
          <div class="d-inline-block mr-2">
            <p class="badge" style="background-color: #08de70; color: white">
              Availability
            </p>
          </div>
          <div class="d-inline-block mr-2">
            <p class="badge" style="background-color: #08debb; color: rgb(255, 253, 253)">
              Performance
            </p>
          </div>

          <div class="d-inline-block mr-2">
            <p class="badge" style="background-color: #0865de; color: rgb(255, 253, 253)">
              Quality
            </p>
          </div>

          <div class="d-inline-block mr-2">
            <p class="badge" style="background-color: #de7a08; color: rgb(255, 254, 254)">
              Oee
            </p>
          </div>
          <app-barchart [seriesdata]="seriesdata" [labels]="filteredData"></app-barchart>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card">
        <div class="card-body" *ngIf="!showTable">
          Please wait we are fetching data / nodata
          <img src="assets/images/noData.jpg" width="70%" />
        </div>
        <div class="card-body" *ngIf="showTable">
          <div class="d-inline-block mr-2">
            <p class="badge" style="background-color: #548237; color: white">
              Running
            </p>
          </div>
          <div class="d-inline-block mr-2">
            <p class="badge" style="background-color: #f7c030; color: rgb(255, 253, 253)">
              Idle
            </p>
          </div>
          <div class="d-inline-block mr-2">
            <p class="badge" style="background-color: #b0b0b0; color: rgb(255, 254, 254)">
              Off
            </p>
          </div>
          <app-statusbarchart *ngIf="showTable" [seriesdata]="statusGraph" [labels]="shift_list"></app-statusbarchart>
        </div>
      </div>
    </div> -->

    <div class="col-md-12">
      <div class="card">
        <!-- <div class="card-header" style="background-color: #E4EFE7 !important;">
          Day Report
        </div> -->
        <div class="card-body">
          <div *ngIf="!showTable">
            Please wait we are fetching data / nodata
            <!-- <img src="assets/images/noData.jpg" width="70%" /> -->
          </div>
          <!-- <h4 class="card-title">Dark Table</h4> -->
          <!-- <p class="card-title-desc">
            You can also invert the colors—with light text on dark
            backgrounds—with <code>.table-dark</code>.
          </p> -->

          <div class="table-responsive" *ngIf="showTable && selectedType == 'Hourly'">
            <table class="table mb-0">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Hour</th>
                  <th>Current (amp)</th>
                  <th>Part Count</th>
                  <th>Part Produced</th>
                  <th>Part Rejected</th>
                  <th>Real Power (W)</th>
                  <th>Apparent Power (VA)</th>
                  <th>Energy Consumption (%)</th>
                  <th>Total Energy (KwH)</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="
                  let data of tablehourlyData
                    | slice : pageSize
                    | slice : 0 : itemsPerPage;
                  let i = index
                ">
                  <th>{{ data.date }}</th>
                  <th>{{data.endHour}}</th>
                  <td>{{ data.avg_current }}</td>
                  <td>{{ data.Ai_partcount ? data.Ai_partcount : "0" }}</td>
                  <td>{{ data.total_part_count ? data.total_part_count : "0" }}</td>
                  <td>{{ data.total_part_reject ? data.total_part_reject : "0" }}</td>
                  <td>{{ data.avg_real_power ? data.avg_real_power : "-" }}</td>
                  <td>{{ data.avg_apparent_power ? data.avg_apparent_power : "-" }}</td>
                  <td>
                    {{
                    data.avg_energy_consumption ? data.avg_energy_consumption : "-"
                    }}
                  </td>
                  <td>{{ data.avg_total_energy ? data.avg_total_energy : "-" }}</td>
                </tr>
              </tbody>
            </table>
            <div class="col-md-6" *ngIf="tablehourlyData.length > 5">
              <ngb-pagination class="pagination-rounded" [collectionSize]="tablehourlyData?.length" #numPages
                [pageSize]="itemsPerPage" [(page)]="currentPage" [maxSize]="1" [rotate]="true" [ellipses]="false"
                [boundaryLinks]="true" (pageChange)="onPageChange(currentPage)">
              </ngb-pagination>
            </div>
          </div>
          <div class="table-responsive" *ngIf="showTable && selectedType == 'Shift'">
            <table class="table mb-0">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Shift_Name</th>
                  <th>Current (amp)</th>
                  <!-- <th>Availability %</th>
                  <th>Performance %</th>
                  <th>Quality %</th>
                  <th>OEE %</th> -->
                  <th>Part Count</th>
                  <th>Part Produced</th>
                  <th>Part Rejected</th>
                  <!-- <th>Real Power (W)</th> -->
                  <!-- <th>Apparent Power (VA)</th> -->
                  <!-- <th>Energy Consumption (%)</th> -->
                  <th>Total Energy (KwH)</th>
                  <!-- <th>Idle</th>
                  <th>Dryrun</th>
                  <th>Running</th>
                  <th>Warning</th>
                  <th>Alarm</th> -->
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="
                    let data of tableData
                      | slice : pageSize
                      | slice : 0 : itemsPerPage;
                    let i = index
                  ">
                  <th>{{ data.date }}</th>
                  <td>{{ data.shift_name }}</td>
                  <td>{{ data.current_avg }}</td>
                  <td>{{ data.Ai_partcount ? data.Ai_partcount : "0" }}</td>
                  <td>{{ data.total_part_count ? data.total_part_count : "0" }}</td>
                  <td>{{ data.total_part_reject ? data.total_part_reject : "0" }}</td>
                  <!-- <td>{{ data.avg_real_power ? data.avg_real_power : "0" }}</td> -->
                  <!-- <td>{{ data.avg_apparent_power ? data.avg_apparent_power : "0" }}</td> -->
                  <!-- <td>{{ data.avg_energy_consumption ? data.avg_energy_consumption : "0" }}</td> -->
                  <td>{{ data.avg_total_energy ? data.avg_total_energy : "0" }}</td>
                </tr>
              </tbody>
            </table>
            <div class="col-md-6" *ngIf="tableData.length > 5">
              <ngb-pagination class="pagination-rounded" [collectionSize]="tableData?.length" #numPages
                [pageSize]="itemsPerPage" [(page)]="currentPage" [maxSize]="1" [rotate]="true" [ellipses]="false"
                [boundaryLinks]="true" (pageChange)="onPageChange(currentPage)">
              </ngb-pagination>
            </div>
          </div>
          <div class="table-responsive" *ngIf="showTable && selectedType == 'Day'">
            <table class="table table-striped table-bordered table-centered datatable dt-responsive nowrap mb-0">
              <thead class="thead-dark">
                <tr>
                  <th>Date<span style="color: white;">(YYYY:MM:DD)</span></th>
                  <th>PartName</th>
                  <th>OperationNumber</th>
                  <th>Production(hr)</th>
                  <th>PlannedPart</th>
                  <th>PartProduced</th>
                  <th>HourlyAverage_ProductionRate</th>
                  <th>PartRejected</th>
                  <th>Running(hr)</th>
                  <th>Idle(hr)</th>
                  <th>Off(hr)</th>

                </tr>
              </thead>
              <tbody>
                <tr *ngFor="
                    let data of tableDayData
                      | slice : pageSize
                      | slice : 0 : itemsPerPage;
                    let i = index
                  ">
                  <td>{{ data.date }}</td>
                  <td>{{ data.partName? data.partName:'--' }}</td>
                  <td>{{ data.operationNumber? data.operationNumber:'--' }}</td>
                  <td>{{ data.productionHour? data.productionHour:'00:00:00' }}</td>
                  <td>{{ data.plannedPart? data.plannedPart:0 }}</td>
                  <td>{{ data.Ai_partcount? data.Ai_partcount:0 }}</td>
                  <td>{{ data.hourlyAverage_ProductionRate? data.hourlyAverage_ProductionRate:0 }}</td>
                  <td>{{ data.total_part_reject? data.total_part_reject:0 }}</td>
                  <!-- <td>{{ data.avg_current }}</td> -->
                  <td>{{formattime(data.total_running)}}</td>
                  <td>{{formattime(data.total_idle)}}</td>
                  <!-- <td>{{formattime(data.total_standBy)}}</td> -->
                  <td>{{formattime(data.total_off)}}</td>
                  <!-- <td>{{ data.total_part_count ? data.total_part_count : "0" }}</td> -->
                  <!-- <td>{{ data.avg_real_power ? data.avg_real_power : "0" }}</td> -->
                  <!-- <td>{{ data.avg_apparent_power ? data.avg_apparent_power : "0" }}</td> -->
                  <!-- <td>{{ data.avg_energy_consumption ? data.avg_energy_consumption : "0" }}</td> -->
                  <!-- <td>{{ data.avg_total_energy ? data.avg_total_energy : "0" }}</td>
                  <td>{{ data.energyCost ? data.energyCost : "0" }}</td> -->
                </tr>
              </tbody>
            </table>
            <div class="col-md-6" *ngIf="tableDayData?.length > 5">
              <ngb-pagination class="pagination-rounded" [collectionSize]="tableDayData?.length" #numPages
                [pageSize]="itemsPerPage" [(page)]="currentPage" [maxSize]="1" [rotate]="true" [ellipses]="false"
                [boundaryLinks]="true" (pageChange)="onPageChange(currentPage)">
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="col-md-12">
      <div class="card">
        <div class="card-header"style="background-color: #E4EFE7 !important;">
          Hourly Part Count
        </div>
        <div class="card-body">
          <div *ngIf="!showTable">
            Please wait, we are fetching data / No data available
          </div>
          <div class="table-responsive">
            <table class="table mb-0" *ngIf="showTable && selectedType == 'Day'">
              <thead>
                <tr>
                  <th>Date<span style="color: white;">(YYYY:MM:DD)</span></th>
                  <th *ngFor="let da of hourlyDayData" style="white-space: nowrap;">{{ da.Hours }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="tableDayData && tableDayData.length > 0">
                  <td>{{ tableDayData[0]?.date }}</td>
                  <td *ngFor="let item of hourlyDayData" style="text-align: center;">{{ item.Ai_partcount }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div> -->

  </div>
</div>

<ng-template #templatepdf role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">{{ action }}</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click'); cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body card-body">
    <div class="example-container">
      <ul ngbNav #justifiednav="ngbNav" [activeId]="1" class="nav-pills nav-justified">
        <li (click)="directExpo()" [ngbNavItem]="1">
          <a ngbNavLink>
            <h6 class="">Direct Export</h6>
          </a>
          <ng-template ngbNavContent>
            <ng-template [ngTemplateOutlet]="directExport"></ng-template>
          </ng-template>
        </li>
        <li (click)="mailexport()" [ngbNavItem]="2">
          <a ngbNavLink>
            <h6 class="">Export via Email</h6>
          </a>
          <ng-template ngbNavContent>
            <ng-template [ngTemplateOutlet]="mailExport"></ng-template>
          </ng-template>
        </li>
      </ul>
      &nbsp;&nbsp;
      <div [ngbNavOutlet]="justifiednav"></div>
      <div class="text-right mt-3">
        <button *ngIf="!exportViaMail" type="submit" class="btn btn-info round waves-effect headr"
          (click)="modal('Cross click'); download()">
          Export
        </button>
        <button *ngIf="exportViaMail" type="submit" class="btn btn-info round waves-effect headr"
          (click)="modal('Cross click'); download()" [disabled]="!mailform.get('email').value">
          Export
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #directExport>
  <form>
    <div>
      <p>Select the file type you would like to export</p>
    </div>
    <span class="pdf" [ngStyle]="{ 'background-color': pdfBool ? '#C4A484' : null }"><i class="fas fa-file-pdf"
        (click)="pdf()"> PDF </i></span>&nbsp;&nbsp;
    <span class="csv" [ngStyle]="{ 'background-color': csvBool ? '#90EE90' : null }"><i class="fas fa-file-csv"
        (click)="csv()"> CSV </i></span>
    &nbsp;&nbsp;
  </form>
</ng-template>
<ng-template #mailExport>
  <div>
    <p>Select the file type you would like to export</p>
  </div>
  <span class="pdf" [ngStyle]="{ 'background-color': pdfBool ? '#C4A484' : null }"><i class="fas fa-file-pdf"
      (click)="pdf()"> PDF </i></span>&nbsp;&nbsp;
  <span class="csv" [ngStyle]="{ 'background-color': csvBool ? '#90EE90' : null }"><i class="fas fa-file-csv"
      (click)="csv()"> CSV </i></span>&nbsp;&nbsp;
  <div>
    <form [formGroup]="mailform">
      <div class="form-group col-md-8">
        &nbsp;&nbsp;

        <input class="form-control" id="email" placeholder="user@gmail.com" formControlName="email" required
          [ngClass]="{ 'is-invalid': isEmailInvalid() }" />
        <div *ngIf="isEmailInvalid()">
          <span *ngIf="email.hasError('required')" style="color: red">Email is required</span>
          <span *ngIf="email.hasError('email')" style="color: red">Invalid email address</span>
        </div>
      </div>
    </form>
  </div>
</ng-template>
